// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs-module__tabsContainer--1ZAEJ","tabSelected":"Tabs-module__tabSelected--UsECK","tab":"Tabs-module__tab--gabWg"};